import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const swalFunc = (
  title,
  confirmFunc,
  icon = "default",
  confirmBtnColor = "#1d8448",
  cancelBtnColor = "#d33",
  confirmBtnTxt = "بله",
  cancelBtnTxt = "خیر"
) => {
  Swal.fire({
    title: title,
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText: confirmBtnTxt,
    cancelButtonText: cancelBtnTxt,
  }).then((result) => {
    if (result.isConfirmed) {
      confirmFunc();
    }
  });
};
const objToFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

const pathMaker = (path) => {
  let temp = `https://3940.ir/catalog-api/${path}`;
  return path != null ? temp : null;
};
const TimeStampToJalali = (timestamp, format) => {
  let date = new DateObject({
    date: timestamp,
  }).convert(persian, persian_fa);
  return date.format(format);
};
export { swalFunc, objToFormData, pathMaker, TimeStampToJalali };
